import type { RouteRecordRaw } from 'vue-router'

const enterpriseRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/remaps-home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/find-talent',
    name: 'FindTalent',
    component: () => import('@/views/find-talent/find-talent.vue'),
    meta: {
      title: '寻找岗位'
    }
  },
  {
    path: '/find-talent/:id',
    name: 'JobDetail',
    component: () => import('@/views/find-talent/detail/job-detail.vue'),
    meta: {
      title: '岗位详情',
      solidHeader: true
    }
  },
  {
    path: '/our-services',
    name: 'OurServices',
    component: () => import('@/views/our-services/our-services.vue'),
    meta: {
      title: '我们的服务'
    }
  },
  {
    path: '/industry-trends',
    name: 'IndustryTrends',
    component: () => import('@/views/industry-trends/industry-trends.vue'),
    meta: {
      title: '行业动态'
    }
  },
  {
    path: '/industry-trends-detail',
    name: 'ArticleDetail',
    component: () => import('@/views/industry-trends/detail/article-detail.vue'),
    meta: {
      title: '行业动态',
      solidHeader: true
    }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/privacy-policy/privacy-policy.vue'),
    meta: {
      title: '隐私政策',
      solidHeader: true
    }
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: () => import('@/views/about-us/about-us.vue'),
    meta: {
      title: '关于我们',
      solidHeader: true
    }
  },
  {
    path: '/cookie-policy',
    name: 'CookiePolicy',
    component: () => import('@/views/cookie-policy/cookie-policy.vue'),
    meta: {
      title: 'Cookie 政策',
      solidHeader: true
    }
  },
  {
    path: '/legal-statement',
    name: 'LegalStatement',
    component: () => import('@/views/legal-statement/legal-statement.vue'),
    meta: {
      title: '法律声明',
      solidHeader: true
    }
  }
]

export default enterpriseRoutes
